import React from 'react';
import { Col, Row, Modal, ModalBody, Button, Badge, Spinner } from 'reactstrap';

export default function ModalConsultaAulasGrupo({
    isOpen,
    toggle,
    aulas = [],
    loading = false,
    periodoLetivoDesc,
    semestreDesc,
    turmaDesc
}) {
    // Exibe apenas as aulas que possuem pendências de grupos
    const aulasPendentes = aulas.filter(aula => aula.total_grupos_faltantes > 0);

    return (
        <Modal 
            isOpen={isOpen} 
            toggle={toggle} 
            style={{ maxWidth: '94%', width: '94%' }}
        >
            <ModalBody>
                {/* Cabeçalho */}
                <Row className="menu-modal-formal mb-3">
                    <Col sm={12} className="align-content-middle mt-2">
                        <h5><b>Consulta de Aulas por Grupos - {periodoLetivoDesc} - {semestreDesc} {turmaDesc}</b></h5>
                    </Col>
                </Row>

                {/* Resultados e Informações */}
                <Row className="px-3 mb-2">
                    <Col className="d-flex justify-content-between align-items-center pl-0 pr-0">
                        <span className="text-muted">
                            {aulasPendentes.length > 0 && (
                                <b>Total de aulas encontradas com pendências: {aulasPendentes.length}</b>
                            )}
                        </span>
                    </Col>
                </Row>

                {/* Tabela de Resultados */}
                <Row className="px-3">
                    {loading && (
                        <div className="text-center w-100 py-5">
                            <Spinner color="primary" />
                            <p className="mt-2 text-muted">Carregando listagem de aulas...</p>
                        </div>
                    )}

                    {!loading && aulasPendentes.length > 0 && (
                        <div style={{ maxHeight: '550px', overflowY: 'auto', width: '100%', border: '1px solid #dee2e6', borderRadius: '4px' }}>
                            <table className="table table-striped table-hover table-bordered table-sm mt-0 mb-0">
                                <thead style={{ position: 'sticky', top: 0, backgroundColor: '#f8f9fa', zIndex: 2 }}>
                                    <tr>
                                        <th className="p-2" style={{ width: '45%' }}>Aula</th>
                                        <th className="p-2" style={{ width: '15%' }}>Tipo Atividade</th>
                                        <th className="p-2" style={{ width: '20%' }}>Status Alocação</th>
                                        <th className="p-2" style={{ width: '20%' }}>Grupos Faltantes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {aulasPendentes.map((aula, idx) => {
                                        return (
                                            <React.Fragment key={aula.id + '_' + idx}>
                                                <tr>
                                                    <td className="p-2">
                                                        <b>{aula.titulo}</b>
                                                    </td>
                                                    <td className="p-2">{aula.tipo_atividade}</td>
                                                    <td className="p-2">
                                                        <Badge color="danger">
                                                            PENDENTE ({aula.total_grupos_faltantes} grupos)
                                                        </Badge>
                                                    </td>
                                                    <td className="p-2">
                                                        <div className="d-flex flex-wrap" style={{ gap: '4px' }}>
                                                            {aula.grupos_faltantes.map(g => (
                                                                <Badge key={g.id} color="warning" style={{ fontSize: '0.75rem' }}>
                                                                    {g.descricao}
                                                                </Badge>
                                                            ))}
                                                        </div>
                                                    </td>
                                                </tr>
                                                
                                                {/* Detalhamento das alocações existentes desta aula */}
                                                <tr>
                                                    <td colSpan="4" className="bg-light p-2" style={{ fontSize: '0.85rem' }}>
                                                        <div className="pl-3">
                                                            <strong>Horários de Alocação desta aula:</strong>
                                                            {aula.alocacoes.length === 0 ? (
                                                                <span className="text-muted ml-2">Esta aula ainda não possui nenhum horário alocado.</span>
                                                            ) : (
                                                                <ul className="mb-0 mt-1 pl-4">
                                                                    {aula.alocacoes.map(aloc => {
                                                                        const dataF = aloc.data ? aloc.data.split('-').reverse().join('/') : 'Sem data';
                                                                        const grps = aloc.grupos?.map(g => g.descricao).join(', ') || 'Nenhum';
                                                                        const profs = aloc.professores?.join(', ') || 'Sem prof. alocado';
                                                                        const inicioF = aloc.inicio ? aloc.inicio.substring(0, 5) : '';
                                                                        const fimF = aloc.fim ? aloc.fim.substring(0, 5) : '';
                                                                        const horarioExibicao = inicioF && fimF ? ` (${inicioF} - ${fimF})` : '';
                                                                        return (
                                                                            <li key={aloc.horario_aula_id} className="mb-1">
                                                                                <strong>{dataF}{horarioExibicao}</strong> | 
                                                                                Local: <span className="text-info">{aloc.local || 'Não definido'}</span> | 
                                                                                Professores: <span className="text-dark">{profs}</span> | 
                                                                                Grupos Alocados: <span className="text-primary" style={{ fontWeight: '600' }}>{grps}</span>
                                                                            </li>
                                                                        );
                                                                    })}
                                                                </ul>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    )}
                </Row>

                {/* Rodapé */}
                <Row className="mt-3 px-3">
                    <Col className="d-flex justify-content-end p-0">
                        <Button onClick={toggle} color="secondary" size="md">
                            Fechar
                        </Button>
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    );
}
